import { useEffect, useState } from "react";
import "./AppPTORequests.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { TimeOffRequest, TimeOffRequestExtended, TimeOffRequestStatus } from "winslow-core";
import { apiGetTimeOffRequestsForWorkspace, apiUpdateTimeOffRequestStatus } from "../../../services/TimeOffRequestService";
import { Check, X } from "lucide-react";
import { erGetCPValue } from "../app-employee-records/employeeRecordUtils";

type AppPTORequestsProps = {
}

export const AppPTORequests = ({}: AppPTORequestsProps) => {
    const storeUser = useSelector(selectUser);
    const [requests, setRequests] = useState<TimeOffRequestExtended[] | undefined>(undefined);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        // Fetch time off requests from the server
        (async () => {
            const timeOffRequests = await apiGetTimeOffRequestsForWorkspace(storeUser.currentWorkspaceId || "");

            console.log("[AppPTORequests] timeOffRequests", timeOffRequests);
            if (timeOffRequests) {
                setRequests(timeOffRequests);
            }
        })();
    }, [storeUser?.currentWorkspaceId]);

    const handleApprove = async (requestId: string) => {
        const updatedRequest = await apiUpdateTimeOffRequestStatus(requestId, TimeOffRequestStatus.APPROVED);
        if (updatedRequest && requests) {
            setRequests(requests.map(r => r.id === requestId ? updatedRequest : r));
        }
    };

    const handleReject = async (requestId: string) => {
        const updatedRequest = await apiUpdateTimeOffRequestStatus(requestId, TimeOffRequestStatus.REJECTED);
        if (updatedRequest && requests) {
            setRequests(requests.map(r => r.id === requestId ? updatedRequest : r));
        }
    };

    return (
        <div className="app-pto-requests">
            <div className="app-pto-requests-header">
                Time Off Requests
            </div>
            <div className="app-pto-requests-content">
                {!requests && <div>Loading...</div>}
                {requests?.length === 0 && <div>No time off requests yet.</div>}
                {requests && requests.length > 0 && (
                    <div className="app-pto-requests-grid">
                        <div className="app-pto-requests-grid-header">
                            <div className="app-pto-requests-grid-header-item">Employee</div>
                            <div className="app-pto-requests-grid-header-item">Type</div>
                            <div className="app-pto-requests-grid-header-item">Start Date</div>
                            <div className="app-pto-requests-grid-header-item">End Date</div>
                            <div className="app-pto-requests-grid-header-item">Status</div>
                            <div className="app-pto-requests-grid-header-item">Actions</div>
                        </div>
                        {requests.map((request: TimeOffRequestExtended) => {
                            const er = request.employeeRecord;

                            const firstName = erGetCPValue(er, "system-firstName");
                            const lastName = erGetCPValue(er, "system-lastName");

                            return (
                                <div key={request.id} className="app-pto-requests-grid-row">
                                    <div className="app-pto-requests-grid-item">{firstName} {lastName}</div>
                                    <div className="app-pto-requests-grid-item">{request.paidTimeOffPolicy.type}</div>
                                    <div className="app-pto-requests-grid-item">
                                        {new Date(request.startDate).toLocaleDateString()}
                                    </div>
                                    <div className="app-pto-requests-grid-item">
                                        {new Date(request.endDate).toLocaleDateString()}
                                    </div>
                                    <div className="app-pto-requests-grid-item">{request.status}</div>
                                    <div className="app-pto-requests-grid-item">
                                        {request.status === TimeOffRequestStatus.PENDING && (
                                            <>
                                                <button
                                                    className="app-pto-requests-action-approve"
                                                    onClick={() => handleApprove(request.id)}
                                                >
                                                    <Check size={16} />
                                                </button>
                                                <button
                                                    className="app-pto-requests-action-reject"
                                                    onClick={() => handleReject(request.id)}
                                                >
                                                    <X size={16} />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )   
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};